"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Modal = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    .modal {\n        background-color: rgba(0, 0, 0, 0.4);\n        visibility: hidden;\n        display: block;\n\n        &.visible {\n            .modal-content {\n                opacity: 1;\n                transform: scale(1);\n            }\n        }\n    }\n\n    .modal-content {\n        opacity: 0;\n\n        transform: scale(0.8);\n        transition-delay: 0.3s;\n        transition: opacity 0.2s linear, transform 0.3s cubic-bezier(0, 0, 0, 2.14);\n    }\n\n    .modal-dialog {\n        display: flex;\n        align-items: center;\n        height: 100%;\n    }\n\n    .modal-body {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n        white-space: normal;\n        max-height: 70vh;\n    }\n\n    .modal-footer {\n        justify-content: space-between;\n    }\n"])));

exports.Modal = Modal;